// ==============================|| DEFAULT THEME - TYPOGRAPHY ||============================== //

export default function Typography(fontFamily) {
  return {
    htmlFontSize: 16,
    fontFamily,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 600,
    h1: {
      fontWeight: 600,
      '@media (min-width: 0px)': { fontSize: '1.5rem' },
      '@media (min-width: 768px)': { fontSize: '2rem' },
      '@media (min-width: 1024px)': { fontSize: '2.2rem' },
      '@media (min-width: 1266px)': { fontSize: '2.2rem' },
      '@media (min-width: 1440px)': { fontSize: '2.5rem' }
    },
    h2: {
      fontWeight: 600,
      '@media (min-width: 0px)': { fontSize: '1.2rem' },
      '@media (min-width: 768px)': { fontSize: '1.6rem' },
      '@media (min-width: 1024px)': { fontSize: '1.76rem' },
      '@media (min-width: 1266px)': { fontSize: '1.76rem' },
      '@media (min-width: 1440px)': { fontSize: '2rem' }
    },
    h3: {
      fontWeight: 600,
      fontSize: '1.5rem',
      lineHeight: 1.33
    },
    h4: {
      fontWeight: 600,
      fontSize: '1.25rem',
      lineHeight: 1.4
    },
    h5: {
      fontWeight: 600,
      fontSize: '1rem',
      lineHeight: 1.5
    },
    h6: {
      fontWeight: 400,
      fontSize: '0.875rem',
      lineHeight: 1.57
    },
    caption: {
      fontWeight: 400,
      fontSize: '0.75rem',
      lineHeight: 1.66
    },
    body1: {
      fontSize: '0.875rem',
      lineHeight: 1.57
    },
    body2: {
      fontSize: '0.75rem',
      lineHeight: 1.66
    },
    subtitle1: {
      fontSize: '0.875rem',
      fontWeight: 600,
      lineHeight: 1.57
    },
    subtitle2: {
      fontSize: '0.75rem',
      fontWeight: 500,
      lineHeight: 1.66
    },
    overline: {
      lineHeight: 1.66
    },
    button: {
      textTransform: 'capitalize'
    }
  };
}
